import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FnUtilService, FnToasterService } from 'foundation';
import { EOTeam, EOTeamGroup } from '../../../modal/entity.modal';
import { PosHttpService } from '../../../services/pos.http.service';
import { EOCommentDetail } from '../../../modal/entity.modal';

@Component({
  selector: 'app-dashboard-forword-model',
  templateUrl: './dashboard-forword-model.component.html',
  styleUrl: './dashboard-forword-model.component.scss'
})
export class DashboardForwordModelComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData, private posHttpSvcs: PosHttpService, private dialogRef: MatDialogRef<DashboardForwordModelComponent>, private fnutilservice: FnUtilService, private toaster: FnToasterService) { }

  teamsArray: EOTeam[] = [];
  commentObject: { textComment: string } = { textComment: '' };
  isSendTelegram: boolean = false;
  isSelected: boolean = false;
  commentArr: EOCommentDetail[] = [];

  objectHash: EOTeamGroup = {
    primaryKey: 0,
    id: '',
    isActive: true,
    textDesc: '',
    teams: []
  }

  ngOnInit(): void {
    this.loadTeamArray();
  }
  loadTeamArray() {
    this.posHttpSvcs.authGet('v1/ui/getResolveTeams', 'getResolveTeams').subscribe(((resp: { isError: string; data: EOTeam[]; }) => {
      if (resp.isError) {
        this.toaster.error("EOTeamArray is not loaded");
      }
      this.teamsArray = resp.data;
    }))
  }

  close() {
    this.dialogRef.close();
  }

  Escalate() {
    if (this.fnutilservice.isEmptyObject(this.objectHash.teams)) {
      this.toaster.error('Please select team');
      throw new Error();
    }
    if (this.fnutilservice.isEmptyObject(this.commentObject.textComment)) {
      this.toaster.error('Please add comment');
      return
    }
    const pktData = {
      commentText: this.commentObject.textComment,
      isSendTelegram: this.isSendTelegram,
      teams: this.objectHash.teams,
      pk: this.dialogData.forward.primaryKey
    };
    this.posHttpSvcs.authPost('v1/ui/forward', 'forward', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error(resp.data);
        return;
      } else {
        this.toaster.success(resp.data);
        if (this.isSendTelegram) {
          this.loadComments();
        }
        this.commentObject.textComment = '';
        this.dialogData.forward.viewedBy = '';
      }
      this.dialogRef.close(resp.isError);
    }));

  }
  selectionCheck(event: any): void {
    this.isSelected = event.target.checked;
  }

  loadComments(): void {
    this.posHttpSvcs.authPost('v1/ui/getEOCommentArray', 'getEOCommentArray', this.dialogData.forward.primaryKey).subscribe((resp: { isError: string; data: EOCommentDetail[]; }) => {
      if (resp.isError) {
        this.toaster.error("EOCommentArray is not loaded");
      }
      this.commentArr = resp.data;
      this.sendtoTelegram();
    }
    );
  }

  sendtoTelegram(): void {
    let msg = `Action: Forwarded\n`;

    const filteredComments = this.commentArr.map(comment => {
      return comment;
    });
    if (filteredComments.length === 1) {
      const latestComment = filteredComments[filteredComments.length - 1];
      msg += `Action By : ${latestComment.commentedBy}\n`;
      msg += `Action At : ${latestComment.commentedAt}\n`;
      msg += `Comment : ${latestComment.commentText}\n`;
    } else if (filteredComments.length >= 2) {
      const lastComment = filteredComments[filteredComments.length - 1];
      const latestComment = filteredComments[filteredComments.length - 2];  
      msg += `Action By : ${lastComment.commentedBy}\n`;
      msg += `Action At : ${lastComment.commentedAt}\n`;
      msg += `Comment: ${lastComment.commentText}\n\n`;
      msg += `Last Action By : ${latestComment.commentedBy}\n`;
      msg += `Last Action At : ${latestComment.commentedAt}\n`;
      msg += `Last Comment : ${latestComment.commentText}\n`;
    }

    const isSinglePk = Array.isArray(this.dialogData.forward.primaryKey)
      ? this.dialogData.forward.primaryKey.length === 1
      : true;

    const pktData = {
      msg: isSinglePk ? msg : filteredComments[filteredComments.length - 1].commentText,
      pk: this.dialogData.forward.primaryKey,
      ...(isSinglePk ? {} : { action: 'Forwarded' })
    };
    this.posHttpSvcs.authPost('v1/ui/generateTelegram', 'generateTelegram', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error("Telegram Msg not sent");
        return;
      }
    }));
  }
}

interface HwDialogData {
  forward: any;
}
